import axios from 'axios';
import { apiUrl } from './index';

export default {
  getItems(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/banners`,
      params,
    });
  },
  createItem(banner) {
    return axios({
      method: 'post',
      url: `${apiUrl}/banners`,
      data: {
        ...banner,
      },
    });
  },
  updateItem(banner) {
    return axios({
      method: 'put',
      url: `${apiUrl}/banners/${banner.id}`,
      data: {
        ...banner,
      },
    });
  },
  getItem({ id }) {
    return axios({
      method: 'get',
      url: `${apiUrl}/banners/${id}`,
    });
  },
  getStatuses() {
    return axios({
      method: 'get',
      url: `${apiUrl}/banners/statuses`,
    });
  },
  getPresentableItems() {
    return axios({
      method: 'get',
      url: `${apiUrl}/banners/presentable`,
    });
  },
  setDismissed({ id }) {
    return axios({
      method: 'get',
      url: `${apiUrl}/banners/${id}/close`,
    });
  },
  trackRedirect({ id }) {
    return axios({
      method: 'get',
      url: `${apiUrl}/banners/${id}/visit`,
    });
  },
};
